import { gql } from "@apollo/client";
import { CURRENT_MEMBER_FRAGMENT } from "../fragments";

export const EVENT_DETAILS_FRAGMENT = gql`
  fragment EventDetailsFragment on MembershipEvent {
    id
    title
    description
    registrationOpenAt
    registrationCloseAt
    startsAt
    endsAt
    cancelledAt
    slug
    location
    bannerImageUrl
    termsContent
    printablePass
    registrationFull
    address {
      address1
      city
      state
      zip
    }
    sessions {
      id
      orderKey
      startsAt
      endsAt
      title
      location
      hasAvailability
    }
  }
`;

export const CURRENT_MEMBER_QUERY = gql`
  query getCurrentMember {
    currentMember {
      ...CurrentMemberFragment
    }
  }
  ${CURRENT_MEMBER_FRAGMENT}
`;

export const CREATE_EVENT_REGISTRATION = gql`
  mutation CreateEventRegistration($input: MembershipCreateEventRegistrationInput!) {
    createEventRegistration(input: $input) {
      success
      message
    }
  }
`;

export const EVENT_REGISTRATION_QUERY = gql`
  query eventRegistrationQuery($slug: String!) {
    eventRegistration(slug: $slug) {
      registeredAt
      acceptedTerms
      event {
        title
        description
        startsAt
        endsAt
        cancelledAt
        slug
      }
    }
  }
`;

export const EVENT_ELIGIBILITY_QUERY = gql`
  query eventEligibilityQuery($slug: String!) {
    eventEligibility(slug: $slug) {
      isEligible
      eligibilityErrors
    }
  }
`;
